export default __webpack_public_path__ + "static/media/tick.e3920b54.svg";